import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { mutationUpdateCustomerField } from "Apollo";
import { ShowNotice } from "Store";
import Tooltip from "module-common/Tooltip";
import Icon from "module-common/Icon";
import DeleteButton from "./DeleteButtonWithMutation";

export default graphql(mutationUpdateCustomerField)(
  class FieldRow extends Component {
    static propTypes = {
      customerId: PropTypes.number,
      fieldId: PropTypes.number,
      name: PropTypes.string,
      value: PropTypes.string,
      disabled: PropTypes.bool
    };

    componentWillReceiveProps(nextProps) {
      this.input.value = nextProps.value;
    }

    render() {
      const { customerId, fieldId, name, value, disabled } = this.props;

      const labelName =
        name === "Name" ? (
          <Label>
            {name}
            <Tooltip text={"Name cant be changed"}>
              <Icon name="information" width={10} height={10} />
            </Tooltip>
          </Label>
        ) : (
          <Label>
            {name}
            <Tooltip text={"Press Enter to add " + name}>
              <Icon name="information" width={10} height={10} />
            </Tooltip>
          </Label>
        );

      return (
        <Wrapper>
          {labelName}
          <Colon>:</Colon>
          <form onSubmit={this.onSubmit}>
            <TextInput
              innerRef={ref => (this.input = ref)}
              type="text"
              defaultValue={value}
              readOnly={disabled}
            />
          </form>
          {!disabled && (
            <StyledDeleteButton customerId={customerId} fieldId={fieldId} />
          )}
        </Wrapper>
      );
    }

    onSubmit = async event => {
      this.input.blur();
      event.preventDefault();
      const { customerId, fieldId, mutate } = this.props;
      try {
        await mutate({
          variables: {
            customerInput: { id: customerId },
            customerFieldInput: { id: fieldId },
            content: this.input.value
          },
          refetchQueries: ["customerDetail", "getCustomerJourney"]
        });

        ShowNotice("customer-field-update-success");
      } catch (error) {
        ShowNotice("customer-field-update-error");
      }
    };
  }
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  margin-bottom: 10px;
`;
const Label = styled.label`
  width: 70px;
  flex: none;
`;
const Colon = styled.div`
  margin-left: auto;
  margin-right: 14px;
`;
const TextInput = styled.input`
  width: 100%;
  padding: 4px;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 3px;
  ${props => (props.readOnly ? "background-color: #efefef" : null)};
`;

const StyledDeleteButton = styled(DeleteButton)`
  position: absolute;
  right: 4px;
`;



// WEBPACK FOOTER //
// ./src/module-customer-journey/detail/FieldRow.js